import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import MainMenu from "../components/MainMenu";
import EquipmentList from "../references/equipment/List";
import EquipmentForm from "../references/equipment/Form";
import * as constants from "../assets/constants";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import EquipmentApi from "../api/references/equipment"
class FragmentEquipment extends BaseComponent {


    constructor(props) {
        super(props)
        const state = {

            activePanelEquipment: "panel_equipment_list",
            current_equipment: null,
            getImageEventName: "setImage",

        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    receiveMessage = (event) => {
        if (event.data.type !== undefined && event.data.type === 'setCurrentEquipment') {
            console.log(event)
            this.setState({
                current_equipment: event.data.value,
                activePanelEquipment: event.data.value !== null ? 'panel_equipment_item' : 'panel_equipment_list'
            })
            return
        }

        if (event.data.type !== undefined && event.data.type === 'reloadCurrentEquipment' && this.state.current_equipment.id > 0) {
            EquipmentApi.getOne(this.state.current_equipment.id).then(response => {
                const {data} = response
                if (data.id) {
                    this.setState({current_equipment: data, activePanelEquipment: 'panel_equipment_item'})
                }
            })

            return
        }
    }
    render() {
        return <View activePanel={this.state.activePanelEquipment} >
            <Panel id="panel_equipment_list">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : <SplitCol maxWidth={280}>
                        <MainMenu
                            setActiveModal={(e) => this.setActiveModal(e)}
                            onStoryChange={(e) => this.onStoryChange(e)}
                            setActiveStory={(e) => this.setActiveStory(e)}
                            current_user={this.props.current_user}
                            setState={(state) => this.setState(state)}
                            doLogout={this.doLogout}
                        />
                    </SplitCol>}
                    <SplitCol>
                        <EquipmentList current_user={this.props.current_user}/>
                    </SplitCol>
                    {!AdaptivityContext.isMobile &&
                        <SplitCol>

                        </SplitCol>}
                </SplitLayout>
            </Panel>
            <Panel id="panel_equipment_item">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : <SplitCol maxWidth={280}>
                        <MainMenu
                            setActiveModal={(e) => this.setActiveModal(e)}
                            onStoryChange={(e) => this.onStoryChange(e)}
                            setActiveStory={(e) => this.setActiveStory(e)}
                            current_user={this.props.current_user}
                            setState={(state) => this.setState(state)}
                            doLogout={this.doLogout}
                        />
                    </SplitCol>}
                    <SplitCol>
                        <EquipmentForm
                            current_user={this.props.current_user}
                            item={this.state.current_equipment}
                            base_url={this.state.base_url}
                            eventType="setCurrentEquipment"
                            title_new="Новый стенд"
                            title="Стенд"
                            fields={
                                {
                                    title: {
                                        required: true,
                                        title: 'Наименование',
                                        type: 'text'
                                    },
                                    stand_id: {
                                        title: 'Стенд',
                                        type: 'SelectObject',
                                        app: 'stands',
                                        act: 'getList',
                                        modal_title: 'Список стендов'
                                    },
                                    collection_id: {
                                        title: 'Коллекция',
                                        type: 'SelectObject',
                                        app: 'standcollections',
                                        act: 'getList',
                                        modal_title: 'Список коллекций'
                                    },
                                    is_competitor: {
                                        title: 'Стенд конкурента',
                                        type: 'checkbox'
                                    },
                                    type_id: {
                                        required: true,
                                        title: 'Тип',
                                        type: 'select',
                                        options: constants.getEquipmentTypes()
                                    }
                                }
                            }
                            hideForm={() => this.setState({
                                current_equipment: null,
                                activePanelEquipment: 'panel_equipment_list'
                            })}

                        />
                    </SplitCol>
                    {!AdaptivityContext.isMobile && <SplitCol>
                    </SplitCol>}
                </SplitLayout>
            </Panel>

        </View>
    }

}

export default FragmentEquipment